module.exports = __webpack_public_path__ + "static/img/homeShow.6f6733e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeShow.png
// module id = 3uIk
// module chunks = 0